import { Component, Input } from '@angular/core';
import { Router } from '@angular/router';
import { RouterLinkType } from '@core/common.types';
import { MemoizedSelector } from '@ngrx/store';
import { ResourceState } from '@platform/shared/resource.state';
import { navigateRouterLink } from '@platform/shared/utilities/navigate.util';

@Component({
  selector: 'app-widget',
  templateUrl: './widget.component.html',
  styleUrls: ['./widget.component.scss'],
})
export class WidgetComponent {
  @Input() titleT: string;
  @Input() itemsCount?: number;
  @Input() navigateLink!: RouterLinkType;
  @Input() selectorToWaitFor?: MemoizedSelector<object, ResourceState<any>>;
  @Input() loading?: boolean;

  constructor(private router: Router) {}

  get showItemsCount() {
    return typeof this.itemsCount === 'number';
  }

  navigate() {
    navigateRouterLink(this.router, this.navigateLink);
  }
}
